<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">Product Detail</h1>
        <p style="color: white; padding-top: 10px;">Home > Extra Modules > BI</p>
    </div>
    <div class="container" style="padding-top: 90px;">
        <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12" >
                <h3>{{ $t('em1') }}</h3>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('biP1') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('biP2') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('biP3') }}
                </p>
                <p style="padding-top: 10px; padding-bottom: 10px; color: #888888;">
                    {{ $t('biP4') }}
                </p>
                 <ul style="color: #888888;">
                    <li>{{ $t('biP5') }}</li>
                    <li>{{ $t('biP6') }}</li>
                    <li>{{ $t('biP7') }}</li>
                    <li>{{ $t('biP8') }}</li>
                    <li>{{ $t('biP9') }}</li>
                    <li>{{ $t('biP10') }}</li>
                    <li>{{ $t('biP11') }}</li>
                </ul>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12" style="text-align: center; margin-bottom: 90px;">
                <b-img src="@/assets/EM/em1.jpg" fluid alt="Responsive image"></b-img>
                 <ul style="color: #888888; text-align: left;">
                    <li>{{ $t('biP12') }}</li>
                    <li>{{ $t('biP13') }}</li>
                    <li>{{ $t('biP14') }}</li>
                    <li>{{ $t('biP15') }}</li>
                    <li>{{ $t('biP16') }}</li>
                    <li>{{ $t('biP17') }}</li>
                    <li>{{ $t('biP18') }}</li>
                </ul>
            </div>
        </div>
    </div>
</div> 
</template>

<script>

export default {
  name: 'BI',
  data(){
      return{
       slide: 0,
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
